import { cloneState, type GameState } from '../../engine/game-state.js';

export interface History {
  push(state: GameState): void;
  pop(): GameState | undefined;
  clear(): void;
  size(): number;
}

export function createHistory(): History {
  const stack: GameState[] = [];
  return {
    push(state) { stack.push(cloneState(state)); },
    pop() { return stack.pop(); },
    clear() { stack.length = 0; },
    size() { return stack.length; },
  };
}
